/* ===========================================================================
   Party Yachts Miami — landing behaviour for Shopify

   Handles the carousel arrows and pushes CTA events to the dataLayer so the
   ads agency can build the same triggers they already use:

     event: "cta_click"   with cta_type + cta_location
     event: "yacht_click" with yacht_name
     event: "lead_form_submit"

   Loaded by several sections, so it guards against running twice.
   =========================================================================== */
(function () {
  if (window.__pymLandingInit) return;
  window.__pymLandingInit = true;

  window.dataLayer = window.dataLayer || [];

  // --- Carousel arrows ----------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pym-scroll]');
    if (!btn) return;

    var track = document.getElementById(btn.getAttribute('data-pym-target'));
    if (!track || !track.firstElementChild) return;

    var step = track.firstElementChild.getBoundingClientRect().width + 24;
    var dir = btn.getAttribute('data-pym-scroll') === 'prev' ? -1 : 1;
    track.scrollBy({ left: step * dir, behavior: 'smooth' });
  });

  // Meta pixel is loaded by Shopify's Meta channel, so fbq already exists.
  // These add lead events on top of its ecommerce tracking.
  function meta(event, params, standard) {
    if (typeof window.fbq !== 'function') return;
    try {
      window.fbq(standard ? 'track' : 'trackCustom', event, params || {});
    } catch (e) {}
  }

  // --- CTA tracking -------------------------------------------------------
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-pym-track]');
    if (!el) return;

    var type = el.getAttribute('data-pym-track');
    var where = el.getAttribute('data-pym-location') || 'unknown';

    if (type === 'yacht') {
      var yacht = el.getAttribute('data-pym-yacht') || 'unknown';
      window.dataLayer.push({ event: 'yacht_click', yacht_name: yacht });
      meta('ViewContent', { content_name: yacht, content_type: 'yacht' }, true);
      return;
    }

    if (type === 'lead_submit') return;

    window.dataLayer.push({ event: 'cta_click', cta_type: type, cta_location: where });

    // Calls and WhatsApp chats are leads for Meta too, not just Google.
    if (type === 'call' || type === 'whatsapp' || type === 'sms') {
      meta('Contact', { method: type, placement: where }, true);
    }
  });

  // --- Fire the lead conversion after Shopify's redirect ------------------
  // Shopify reloads the page with ?contact_posted=true on a successful send,
  // so the submit-time event would be lost. This catches the confirmed one.
  try {
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      window.dataLayer.push({ event: 'lead_form_submit_confirmed' });
      meta('Lead', { content_name: 'Charter inquiry' }, true);
    }
  } catch (e) {}
})();
